module.exports = __webpack_public_path__ + "static/media/anders-jilden.7438cd02.jpg";